/**
 * Labstep
 *
 * @module core/Select/Search/Modal/EmptyState
 * @desc Search select modal empty state component
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import type { ActionComponentProps } from 'labstep-web/core/Action/Component/types';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import type { ISearchSelectModalEmptyStateProps } from './types';

const actionComponentProps = {
  type: 'button',
} as ActionComponentProps;

export const SearchSelectModalEmptyState: React.FC<
  ISearchSelectModalEmptyStateProps
> = ({ entityName, creatable, body, options, action }) => (
  <CardEmptyState
    src="/img/empty-state/protocols.svg"
    title={`No ${getHumanReadableEntityName(
      entityName,
      true,
    )} created yet`}
    action={
      creatable &&
      (action || (
        <EntityActionCreate
          entityName={entityName}
          body={body}
          options={options}
          actionComponentProps={actionComponentProps}
        />
      ))
    }
  />
);
